import { ROLE_ADMIN_USER, ROLE_CLIENT_USER, ROLE_PARTNER_USER, ROLE_SUPER_USER } from "../../../utils/constants";

export default {
  roles_superUser: ROLE_SUPER_USER,
  roles_admin: ROLE_ADMIN_USER,
  roles_client: ROLE_CLIENT_USER,
  roles_partner: ROLE_PARTNER_USER,
};
